export let ERROR="ERROR"
export let LOADING="LOADING"
export let FETCHED_DATA="FETCHED_DATA"
export let SINGLE_FETCHED_PRODUCT="SINGLE_FETCHED_PRODUCT"
export let SINGLE_ERROR="SINGLE_ERROR"
export let SINGLE_LOADING="SINGLE_LOADING"